export default "https://cdn.questicon.mathletics.com/assets/images/icon-measure-ruler-42f037a2c47bcfea3d2c31114a3c26c7.svg";